import { render, staticRenderFns } from "./LearningSection.vue?vue&type=template&id=9b59071e&scoped=true&"
import script from "./LearningSection.vue?vue&type=script&lang=js&"
export * from "./LearningSection.vue?vue&type=script&lang=js&"
import style0 from "./LearningSection.vue?vue&type=style&index=0&id=9b59071e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b59071e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VForm,VRadio,VRadioGroup})
